import { RefurbishedProductStateInterface } from "../interfaces/apiV2/shared/RefurbishedProductStateInterface";

const STATE_LABEL_TO_CODE: Record<string, string> = {
    draft: "draft",
    online: "online",
    reserved: "reserved",
    sold: "sold",
    archived: "archived",
};

export const normalizeRefurbishedState = (
    state: string | RefurbishedProductStateInterface,
): RefurbishedProductStateInterface => {
    if (typeof state !== "string") {
        return state;
    }

    const normalizedLabel = state.trim().toLowerCase();
    const code =
        STATE_LABEL_TO_CODE[normalizedLabel] ??
        (normalizedLabel.includes("reserved")
            ? "reserved"
            : normalizedLabel.includes("sold")
              ? "sold"
              : "online");

    return {
        code,
        label: state,
    };
};
